import Vue from 'vue'
import Router from 'vue-router'
import CommonRoute from './common.route'
import PurchaseRoute from './purchase.route'
import GanSuRoute from './gansu.route'

Vue.use(Router)
var router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      meta: {
        isRefresh: false
      },
      component: () => import('@/views/login/login')
    },
    {
      path: '/forgetpwd',
      name: 'forgetPwd',
      meta: {
        isRefresh: false
      },
      component: () => import('@/views/login/forgetpwd')
    },
    {
      path: '/',
      redirect: 'home',
      name: 'index',
      component: () => import('@/views/index'),
      children: [
        ...CommonRoute,
        ...PurchaseRoute,
        ...GanSuRoute,
        { //系统工具
          path: 'tools',
          name: 'tools',
          redirect: '/tools/start',
          meta: {
            isRefresh: false
          },
          component: () => import('@/views/tools/start'),
          children: [
            {
              path: 'index',
              name: 'toolsIndex',
              component: () => import('@/views/tools/index'),
              meta: {
                title: '系统工具',
                isRefresh: false
              }
            }
          ]
        },
        {// 首页
          path: 'index',
          name: '首页',
          // redirect:'/',
          meta: {
            isRefresh: true
          },
          component: () => import('@/views/homeindex'),
          // component: () => import('@/views/home'),
          // component: () => import('@/views/homecopy'),
        },
        {// 数据大屏
          path: '/dataLargeScreen',
          name: 'dataLargeScreen',
          // redirect:'/',
          meta: {
            title: '数据大屏',
            isRefresh: true
          },
          component: () => import('@/views/dataPage'),
          children: [
            { // 全局总览
              path: 'dataLargeScreenGlobal',
              name: 'dataLargeScreenGlobal',
              meta: {
                title: '---- 全局总览',
                isRefresh: true
              },
              component: () => import('@/views/dataLargeScreen')
            },
            { // 按运营商统计
              path: 'dataLargeScreenOperator',
              name: 'dataLargeScreenOperator',
              meta: {
                title: '---- 按运营商统计',
                isRefresh: true
              },
              component: () => import('@/views/dataLargeScreenOperator')
            },
          ]
        },
        { // app限制
          path: 'appLimit',
          name: 'appLimit',
          meta: {
            title: '配置管理 / app限制',
            isRefresh: true
          },
          component: () => import('@/views/common/appmanage/appLimit')
        },
        { // 号卡导出审核
          path: 'cardExportList',
          name: 'cardExportList',
          meta: {
            title: '配置管理 / 号卡导出任务审核',
            isRefresh: true
          },
          component: () => import('@/views/common/card/cardExportList')
        },
        { // app限制
          path: 'appMapping',
          name: 'appMapping',
          meta: {
            title: '配置管理 / app信息管理',
            isRefresh: true
          },
          component: () => import('@/views/common/appmanage/appMapping')
        },
        { // ip跳转链接配置
          path: 'ipSkipUrlConfiguration',
          name: 'ipSkipUrlConfiguration',
          meta: {
            title: '配置管理 / ip跳转链接配置',
            isRefresh: true
          },
          component: () => import('@/views/common/ipSkipUrlConfiguration/limit')
        },
        // 订单查询
        { // 批量补偿
          path: 'BatchCompensation',
          name: 'BatchCompensation',
          meta: {
            title: '订单查询 / 批量补偿',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/BatchCompensation')
        },
        // 号卡订单查询
        { // 号卡订单
          path: 'numberorder',
          name: 'numbercardOrder',
          meta: {
            title: '订单查询 / 号卡订单',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/numbercardOrder')
        },
        { // 信息流
          path: 'informationstream',
          name: 'informationStream',
          meta: {
            title: '订单查询 / 信息流',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/informationStream')
        },
        { // 辽宁移动商机订单查询
          path: 'lnBusinessquery',
          name: 'lnBusinessquery',
          meta: {
            title: '订单查询 / 辽宁移动商机订单查询',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/lnBusinessquery')
        },
        { // 订单回传列表查询
          path: 'orderReturnList',
          name: 'orderReturnList',
          meta: {
            title: '订单查询 / 订单回传查询',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/orderReturnList')
        },
        { // 淘宝充值查询
          path: 'prepaidrefill',
          name: 'prepaidrefill',
          meta: {
            title: '订单查询 / 话费充值查询',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/prepaidrefill')
        },
        { // 信用卡订单查询
          path: 'creditCardOrderQuery',
          name: 'creditCardOrderQuery',
          meta: {
            title: '订单查询 / 信用卡订单查询',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/creditCardOrderQuery')
        },
        { // 营销活动订单查询
          path: 'marketingQuery',
          name: 'marketingQuery',
          meta: {
            title: '订单查询 / 营销活动订单',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/marketingQuery')
        },
        { // 营销活动订单查询(202010优化版)
          path: 'marketingOrderQuery',
          name: 'marketingOrderQuery',
          meta: {
            title: '订单查询 / 营销活动订单',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/marketingOrderQuery')
        },
        { // 宁夏直充订单查询
          path: 'nxzcOrderQuery',
          name: 'NXZCOrderQuery',
          meta: {
            title: '订单查询 / 宁夏直充订单',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/NXZCOrderQuery')
        },
        { // 在途订单状态查询
          path: 'orderStatusQuery',
          name: 'orderStatusQuery',
          meta: {
            title: '订单查询 / 在途订单',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/orderStatusQuery')
        },
        { // 失败订单查询
          path: 'failOrderQuery',
          name: 'failOrderQuery',
          meta: {
            title: '订单查询 / 失败订单查询',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/failOrderQuery')
        },
        { // 集运号卡订单查询
          path: 'jiyunCardQuery',
          name: 'jiyunCardQuery',
          meta: {
            title: '订单查询 / 集运号卡订单查询',
            isRefresh: true
          },
          component: () => import('@/views/common/orderquery/jiyunCardQuery')
        },
        { // 流量订单列表
          path: 'shanxi/flowlist',
          name: 'sxFlowlist',
          meta: {
            title: '订单查询 / 陕西流量订单',
            isRefresh: true
          },
          component: () => import('@/views/shanxi/orderquery/flowlist')
        },
        { // 全部流量（包含营销活动送的流量到账）
          path: 'ningxia/flowlist',
          name: 'nxFlowlist',
          meta: {
            title: '订单查询 / 流量订单',
            isRefresh: true
          },
          component: () => import('@/views/ningxia/orderquery/flowlist')
        },
        { // 陕西宽带查询
          path: 'shanxi/broadbandquery',
          name: 'sxBroadbandList',
          meta: {
            title: '订单查询 / 陕西移动宽带订单',
            isRefresh: true
          },
          component: () => import('@/views/shanxi/orderquery/broadband')
        },
        { // 陕西移动流量直冲数据展示
          path: 'shanxi/flowstatistics',
          name: 'sxFlowStatistics',
          meta: {
            title: '订单查询 / 陕西流量直充数据',
            isRefresh: true
          },
          component: () => import('@/views/shanxi/orderquery/flowstatistics')
        },
        { // 宁夏宽带订单
          path: 'broadband',
          name: 'nxBroadbandList',
          meta: {
            title: '订单查询 / 宁夏移动宽带订单',
            isRefresh: true
          },
          component: () => import('@/views/ningxia/orderquery/broadband')
        },
        { // 宁夏话费宝列表
          path: 'report/nxHfbReport',
          name: 'nxHfbReport',
          meta: {
            title: '订单查询 / 宁夏话费宝',
            isRefresh: true
          },
          component: () => import('@/views/report/nxHfbReport')
        },
        { // 电商同步订单
          path: 'ecommerce/orderlist',
          name: 'ebOrderList',
          meta: {
            title: '电商订单 / 订单列表',
            isRefresh: true
          },
          component: () => import('@/views/ecommerce/orderlist')
        },
        { // 号卡下单及套餐变更
          path: 'placeorderandsetmealchange',
          name: 'placeorderandsetmealchange',
          meta: {
            title: '订单下单 / 号卡下单or套餐变更',
            isRefresh: true
          },
          component: () => import('@/views/common/placeOrder/placeOrderAndSetMealChange'),
          children: [
            { // 陕西移动号卡下单
              path: 'shanxi/placeorder',
              name: 'sxPlaceorder',
              meta: {
                title: '---- 陕西移动号卡下单',
                isRefresh: true
              },
              component: () => import('@/views/shanxi/placeOrder/placeorder')
            },
            { // 陕西叠加流量套餐
              path: 'shanxi/flowmeal',
              name: 'sxFlowmeal',
              meta: {
                title: '---- 陕西流量套餐变更',
                isRefresh: true
              },
              component: () => import('@/views/shanxi/placeOrder/flowmeal')
            },
            { // 宁夏号卡下单
              path: 'ningxia/placeorder',
              name: 'nxPlaceorder',
              meta: {
                title: '---- 宁夏移动号卡下单',
                isRefresh: true
              },
              component: () => import('@/views/ningxia/placeOrder/order')
            },
            { // 宁夏叠加流量套餐
              path: 'ningxia/flowmeal',
              name: 'nxFlowmeal',
              meta: {
                title: '---- 宁夏流量套餐变更',
                isRefresh: true
              },
              component: () => import('@/views/ningxia/placeOrder/flowmeal')
            },
            { // 广西号卡下单
              path: 'guangxi/placeorder',
              name: 'gxPlaceorder',
              meta: {
                title: '---- 广西移动号卡下单',
                isRefresh: true
              },
              component: () => import('@/views/guangxi/placeOrder/placeorder')
            },
            { // 陕西联通号卡下单
              path: 'chu/shaanxi/cardorder',
              name: 'chuShaanxiCardorder',
              meta: {
                title: '---- 陕西联通号卡下单',
                isRefresh: true
              },
              component: () => import('@/views/chu/shaanxi/cardOrder')
            },
            { // 集运号卡
              path: 'jiyun/card',
              name: 'jiyunCard',
              meta: {
                title: '---- 集运号卡下单',
                isRefresh: true
              },
              component: () => import('@/views/common/placeOrder/jycard')
            },
          ]
        },
        { // 陕西电信号卡下单
          path: 'shanxi/dxplaceorder',
          name: 'sxdxPlaceorder',
          meta: {
            title: '订单下单 / 陕西电信号卡下单',
            isRefresh: true
          },
          component: () => import('@/views/shanxi/placeOrder/dxplaceorder')
        },
        { // 陕西电信号卡小白卡下单
          path: 'shanxi/dxxbplaceorder',
          name: 'sxdxxbPlaceorder',
          meta: {
            title: '订单下单 / 陕西电信小白卡下单',
            isRefresh: true
          },
          component: () => import('@/views/shanxi/placeOrder/dxxbplaceorder')
        },
        { // 陕西电信号卡小白卡下单-带选号
          path: 'shanxi/dxxbPlaceOrderWithNumPool',
          name: 'sxdxxbPlaceOrderWithNumPool',
          meta: {
            title: '订单下单 / 陕西电信小白卡下单(带选号)',
            isRefresh: true
          },
          component: () => import('@/views/shanxi/placeOrder/dxxbPlaceOrderWithNumPool')
        },
        { // 新疆号卡下单
          path: 'xinjiang/placeorder',
          name: 'xjPlaceorder',
          meta: {
            title: '订单下单 / 新疆移动号卡下单',
            isRefresh: true
          },
          component: () => import('@/views/xinjiang/placeOrder/placeorder')
        },
        { // 重庆电信号卡下单
          path: 'chongqing/placeorder',
          name: 'cqPlaceorder',
          meta: {
            title: '订单下单 / 重庆电信号卡下单',
            isRefresh: true
          },
          component: () => import('@/views/chongqing/placeOrder/placeorder')
        },
        { // 重庆花卡下单
          path: 'chongqing/cardorder',
          name: 'cqCardorder',
          meta: {
            title: '订单下单 / 重庆花卡下单',
            isRefresh: true
          },
          component: () => import('@/views/chongqing/cardOrder/cardOrder')
        },
        { // 宁夏宽带办理
          path: 'ningxia/broadband',
          name: 'placeNxBroadband',
          meta: {
            title: '订单下单 / 宁夏宽带下单',
            isRefresh: true
          },
          component: () => import('@/views/ningxia/placeOrder/broadband')
        },
        { // 陕西宽带办理
          path: 'shanxi/broadbandplace',
          name: 'sxBroadbandPlace',
          meta: {
            title: '订单下单 / 陕西移动宽带下单预约',
            isRefresh: true
          },
          component: () => import('@/views/shanxi/placeOrder/broadband')
        },
        { // 号码池
          path: 'poolList',
          name: 'poolList',
          meta: {
            title: '配置管理 / 号码池管理',
            isRefresh: true
          },
          component: () => import('@/views/common/manage/poolList')
        },
        { // 号码池
          path: 'uppool',
          name: 'uppool',
          meta: {
            title: '配置管理 / 号池管理 / 上传号码',
            isRefresh: true
          },
          component: () => import('@/views/common/manage/uppool')
        },
        { // 号卡配置
          path: 'numberCard',
          name: 'numberCard',
          meta: {
            title: '配置管理 / 号卡套餐配置',
            isRefresh: true
          },
          component: () => import('@/views/common/manage/numberCard')
        },
        { // 商品配置
          path: 'goodsSettings',
          name: 'goodsSettings',
          meta: {
            title: '配置管理 / 商品配置',
            isRefresh: true
          },
          // component: () => import('@/views/common/manage/goodsSettingscopy.vue')
          component: () => import('@/views/common/manage/goodsSettings.vue')
        },
        { // 业务规则管理
          path: 'businessRulesManagement',
          name: 'businessRulesManagement',
          meta: {
            title: '配置管理 / 业务规则管理',
            isRefresh: true
          },
          component: () => import('@/views/common/manage/businessRulesManagement.vue')
        },
        { // 宁夏宽带配置
          path: 'ningxia/broad',
          name: 'nxBroad',
          meta: {
            title: '配置管理 / 号卡套餐配置',
            isRefresh: true
          },
          component: () => import('@/views/ningxia/manage/broad')
        },
        { // 陕西流量配置
          path: 'shanxi/flowpackage',
          name: 'sxFlowpackage',
          meta: {
            title: '配置管理 / 陕西流量配置',
            isRefresh: true
          },
          component: () => import('@/views/shanxi/manage/flowpackage')
        },
        { // 宁夏流量配置
          path: 'ningxia/flowpackage',
          name: 'nxFlowpackage',
          meta: {
            title: '配置管理 / 宁夏流量配置',
            isRefresh: true
          },
          component: () => import('@/views/ningxia/manage/flowpackage')
        },
        { // 陕西宽带配置
          path: 'shanxi/broadbandpackage',
          name: 'sxBroadbandpackage',
          meta: {
            title: '配置管理 / 陕西移动宽带套餐配置',
            isRefresh: true
          },
          component: () => import('@/views/shanxi/manage/broadband')
        },
        { // 系统管理
          path: '/system',
          name: 'system',
          redirect: '/system/start',
          component: () => import('@/views/system/start'),
          children: [
            {
              path: 'nodelist',
              name: 'nodelist',
              meta: {
                title: '系统管理 / 节点管理',
                isRefresh: true
              },
              component: () => import('@/views/system/node/nodelist')
            },
            {
              path: 'rolelist',
              name: 'rolelist',
              meta: {
                title: '系统管理 / 角色管理',
                isRefresh: true
              },
              component: () => import('@/views/system/role/rolelist')
            },
            {
              path: 'accountlist',
              name: 'accountlist',
              meta: {
                title: '系统管理 / 工号管理',
                isRefresh: true
              },
              component: () => import('@/views/system/user/accountlist')
            },
            {
              path: 'channel',
              name: 'channelIndex',
              meta: {
                title: '系统管理 / 渠道商管理',
                isRefresh: true
              },
              component: () => import('@/views/system/channel/index')
            }
          ]
        },
        { // 拉新赚佣 注册用户列表
          path: '/pullNew/userInfo',
          name: 'userInfo',
          meta: {
            title: '拉新赚佣 / 注册用户',
            isRefresh: true
          },
          component: () => import('@/views/pullNew/userInfo'),
        },
        { // 拉新赚佣 支付宝
          path: '/pullNew/zfbList',
          name: 'zfbPullNew',
          meta: {
            title: '拉新赚佣 / 支付宝拉新',
            isRefresh: true
          },
          component: () => import('@/views/pullNew/zfbList'),
        },
        {// 拉新赚佣 淘宝
          path: '/pullNew/tbList',
          name: 'tbPullNew',
          meta: {
            title: '拉新赚佣 / 淘宝拉新',
            isRefresh: true
          },
          component: () => import('@/views/pullNew/tbList'),
        },
        {// 拉新赚佣 打款记录
          path: '/pullNew/paylist',
          name: 'paylist',
          meta: {
            title: '拉新赚佣 / 打款记录',
            isRefresh: true
          },
          component: () => import('@/views/pullNew/paylist'),
        },
        {// 冰蓝话费平台，转账管理
          path: '/bluerecharge/transferList',
          name: 'transferMoneyList',
          meta: {
            title: '话费平台 / 转账审核',
            isRefresh: true
          },
          component: () => import('@/views/bluerecharge/transferList'),
        },
        {// 充值平台
          path: '/telcharge',
          name: 'telcharge',
          meta: {
            title: '充值平台 / 话费充值',
            isRefresh: true
          },
          component: () => import('@/views/other/telcharge'),
        },
        {// 号卡推广
          path: '/blbusiness/inforcollection',
          name: 'inforcollection',
          meta: {
            title: '业务平台 / 订单列表（号卡推广）',
            isRefresh: true
          },
          component: () => import('@/views/numCardExtend/inforcollection'),
        },
        {// 重庆号卡推广
          path: '/blbusiness/cqCardCollection',
          name: 'cqCardCollection',
          meta: {
            title: '业务平台 / 重庆移动号卡订单',
            isRefresh: true
          },
          component: () => import('@/views/numCardExtend/cqCardCollection'),
        },
        {//用户列表(冰蓝业务平台账号信息)
          path: '/blbusiness/userinfo',
          name: 'extendUsernfo',
          meta: {
            title: '业务平台 / 账号列表（号卡推广）',
            isRefresh: true
          },
          component: () => import('@/views/numCardExtend/userinfolist'),
        },
        {//用户列表(冰蓝业务平台账号信息)
          path: '/blbusiness/channelABMF',
          name: 'channelABMF',
          meta: {
            title: '业务平台 / 渠道余额管理',
            isRefresh: true
          },
          component: () => import('@/views/numCardExtend/channelABMF'),
        },
        {//推广渠道投放管理
          path: '/blbusiness/channelConversion',
          name: 'channelConversion',
          meta: {
            title: '业务平台 / 推广渠道投放管理',
            isRefresh: true
          },
          component: () => import('@/views/numCardExtend/channelConversion'),
        },
        { //系统菜单/系统告警
          path: '/giveAnAlarm/giveAnAlarmDeploy',
          name: 'giveAnAlarmDeploy',
          meta: {
            title: '系统菜单 / 系统告警配置',
            isRefresh: true
          },
          component: () => import('@/views/systemMenu/giveAnAlarmDeploy')
        },
        { //系统菜单/系统告警
          path: '/systemMenu/serviceAlarm',
          name: 'serviceAlarm',
          meta: {
            title: '系统菜单 / 业务告警',
            isRefresh: true
          },
          component: () => import('@/views/systemMenu/serviceAlarm')
        },
        { //系统菜单/系统规则
          path: '/systemMenu/systemRule',
          name: 'systemRule',
          meta: {
            title: '系统菜单 / 系统规则配置',
            isRefresh: true
          },
          component: () => import('@/views/systemMenu/systemRule')
        },
        { //系统菜单/系统通知
          path: '/systemMenu/systemNotification',
          name: 'systemNotification',
          meta: {
            title: '系统菜单 / 系统通知配置',
            isRefresh: true
          },
          component: () => import('@/views/systemMenu/systemNotification')
        },
        { //系统菜单/系统通知
          path: '/systemMenu/BSSlogInfo',
          name: 'BSSlogInfo',
          meta: {
            title: '系统菜单 / BSS操作日志',
            isRefresh: true
          },
          component: () => import('@/views/systemMenu/bssLogInfo')
        },
        { //系统菜单/转账日志
          path: '/systemMenu/billingDetails',
          name: 'billingDetails',
          meta: {
            title: '系统菜单 / 转账日志',
            isRefresh: true
          },
          component: () => import('@/views/systemMenu/billingDetails')
        },
        { //系统菜单/服务监控
          path: '/systemMenu/serverMonitoring',
          name: 'serverMonitoring',
          meta: {
            title: '系统菜单 / 服务监控',
            isRefresh: true
          },
          component: () => import('@/views/systemMenu/serverMonitoring')
        },
        { //易点流量/任务中心
          path: '/flowManagement/taskCenter',
          name: 'taskCenter',
          meta: {
            title: '易点流量 / 号卡广场',
            isRefresh: true
          },
          component: () => import('@/views/flowManagement/taskCenter')
        },
        { //模拟测试/业务模拟
          path: '/simulationTest/BusinessSimulation',
          name: 'BusinessSimulation',
          meta: {
            title: '模拟测试 / 业务模拟',
            isRefresh: true
          },
          component: () => import('@/views/testPages/BusinessSimulationIndex'),

          children: [
            { // 后台下单测试
              path: 'adminBusinessSimulation',
              name: 'adminBusinessSimulation',
              meta: {
                title: '---- 后台下单测试',
                isRefresh: true
              },
              component: () => import('@/views/testPages/BusinessSimulation')
            },
            { // H5下单测试
              path: 'h5BusinessSimulation',
              name: 'h5BusinessSimulation',
              meta: {
                title: '---- H5下单测试',
                isRefresh: true
              },
              component: () => import('@/views/testPages/BusinessSimulationH5')
            },
            { // 测试环境下单测试页
              path: 'goodsAddOrderTest',
              name: 'goodsAddOrderTest',
              meta: {
                title: '测试环境下单测试',
                isRefresh: true
              },
              component: () => import('@/views/testPages/goodsAddOrderTest.vue')
            },
            { // 直充下单测试
              path: 'directChargeOrder',
              name: 'directChargeOrder',
              meta: {
                title: '直充下单测试',
                isRefresh: true
              },
              component: () => import('@/views/testPages/directChargeOrder.vue')
            },
          ]
        },
      ]
    },
    {
      path: '/marketing',
      name: 'marketing',
      component: () => import('@/views/marketing/index'),
      children: [
        { // 陕西话费宝营销活动
          path: '/marketing/shanxi/telcharges',
          name: 'telcharges',
          component: () => import('@/views/marketing/shanxi/telcharges')
        },
        { // 宁夏话费宝-领卡页面
          path: '/marketing/ningxia/gettelnumber',
          name: 'gettelnumber',
          meta: {
            title: '资料填写'
          },
          component: () => import('@/views/marketing/ningxia/gettelnumber')
        }
      ]
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js